"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Output = void 0;
var Spend_1 = require("./Spend");
var LockFactory_1 = require("./Locks/LockFactory");
var Output = /** @class */ (function () {
    function Output(lock, spend) {
        this.lock = lock;
        this.spend = spend;
    }
    Output.read = function (buffer, offset) {
        var _a = LockFactory_1.LockFactory.read(buffer, offset), lock = _a.lock, offset2 = _a.offset;
        var _b = Spend_1.Spend.read(buffer, offset2), spend = _b.spend, offset3 = _b.offset;
        return { output: new Output(lock, spend), offset: offset3 };
    };
    Output.prototype.toJson = function () {
        return {
            lock: this.lock.toJson(),
            spend: this.spend.toJson()
        };
    };
    Output.prototype.toApiJson = function () {
        return {
            lock: LockFactory_1.LockFactory.toApiJson(this.lock),
            spend: this.spend.toJson()
        };
    };
    Output.prototype.getSize = function () {
        return this.lock.getSize() + this.spend.getSize();
    };
    Output.prototype.write = function (buffer, offset) {
        offset = this.lock.write(buffer, offset);
        return this.spend.write(buffer, offset);
    };
    return Output;
}());
exports.Output = Output;
//# sourceMappingURL=Output.js.map